import Swal from "sweetalert2";

export default class Common {

    static isEmpty(text) {
        return !text || text.length === 0;
    }

    static info(text) {
        Swal.fire({
            title: text,
            text: '',
            icon: 'info',
            confirmButtonText: 'Ok'
        })
    }

    static error(text) {
        Swal.fire({
            title: text,
            text: '',
            icon: 'error',
            confirmButtonText: 'Ok'
        })
    }

    static addAddress(uuid, address) {
        return fetch(Common.BASE_API + 'order/myrent/address/' + uuid, {
            method: "POST",
            body: JSON.stringify(address),
            headers: {"Content-Type": "application/json; charset=UTF-8"}
        }).then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static generateMyRentInvoice(rentuuid, addressuuid) {
        return fetch(Common.BASE_API + 'order/myrent/generateinvoice/' + rentuuid + '/' + addressuuid).then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static getRent(uuid) {
        return fetch(Common.BASE_API + 'order/myrent/' + uuid).then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }

    static getPaymentUrlForRent(uuid) {
        return fetch(Common.BASE_API + 'order/myrent/payment/' + uuid).then(function (response) {
            if (response.ok) {
                return response.json();
            } else {
                return Promise.reject(response);
            }
        });
    }
}

Common.BASE_API = 'https://app.busbrat.pl/api/';
